import {
  ACCESSIBILITY_ISOPEN,
  ACCESSIBILITY_DEFAULT_THEME,
  ACCESSIBILITY_BASE_FONT_SIZE,
  ACCESSIBILITY_RESET
} from '../actions/accessibility';

const initialState = {
  isOpen: false,
  baseFontSize: 100,
  defaultTheme: false
};

const accessibility = (state = initialState, action) => {
  switch (action.type) {
    case ACCESSIBILITY_ISOPEN:
      if (!state.isOpen) {
        document.body.classList.add('accessibility--is-open');
      } else {
        document.body.classList.remove('accessibility--is-open');
      }
      return {
        ...state,
        isOpen: !state.isOpen
      };

    case ACCESSIBILITY_DEFAULT_THEME: {
      window.localStorage.setItem('ACCESSIBILITY_DEFAULT_THEME', Boolean(action.status));

      return {
        ...state,
        defaultTheme: action.status
      };
    }
    case ACCESSIBILITY_BASE_FONT_SIZE:
      return {
        ...state,
        baseFontSize: action.payload
      };
    case ACCESSIBILITY_RESET:
      document.body.classList.remove('accessibility--is-open');
      return {
        ...state,
        isOpen: false
      };

    default:
      return state;
  }
};

export default accessibility;
